/**
 * ChatPage - New invisible chatbox interface
 * Main page for the conversational quote configuration flow
 */

import type React from "react";
import { ChatInterface } from "../components/ChatInterface";

export const ChatPage: React.FC = () => {
  const handleQuoteSubmit = (quoteData: Record<string, any>) => {
    console.log("Quote submitted:", quoteData);
    // TODO: Send to backend API
    // This will be implemented in Phase 11 (Quote Submission)
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <ChatInterface onQuoteSubmit={handleQuoteSubmit} />
    </div>
  );
};
